import {AttendanceVisualSummary} from './buildAttendanceVisualSummary'

export function formatAttendanceExportSummaryLines(
  summary: AttendanceVisualSummary | null | undefined
): string[] {
  if (!summary) return []

  if (summary.mode === 'stats') {
    return summary.statPairs
      .map((p) => `${p.metric}: ${p.value}`)
      .filter((line) => line.trim() !== ':')
  }

  const lines: string[] = []
  if (summary.totalRecords > 0) {
    lines.push(`Records: ${summary.totalRecords}`)
  }
  if (summary.presentPercent != null) {
    lines.push(`Present: ${summary.presentPercent}%`)
  }
  for (const seg of summary.statusSegments) {
    const norm = seg.label.trim().toLowerCase()
    if (summary.presentPercent != null && norm === 'present') continue
    lines.push(`${seg.label}: ${seg.count}`)
  }
  return lines
}
